export function IncreasingBarsIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1.5 9.83333C1.5 8.91286 2.24619 8.16667 3.16667 8.16667H4.83333C5.75381 8.16667 6.5 8.91286 6.5 9.83333V14.8333C6.5 15.7538 5.75381 16.5 4.83333 16.5H3.16667C2.24619 16.5 1.5 15.7538 1.5 14.8333V9.83333Z'
        fill='white'
      />
      <path
        d='M6.5 6.5C6.5 5.57953 7.24619 4.83333 8.16667 4.83333H9.83333C10.7538 4.83333 11.5 5.57953 11.5 6.5V14.8333C11.5 15.7538 10.7538 16.5 9.83333 16.5H8.16667C7.24619 16.5 6.5 15.7538 6.5 14.8333V6.5Z'
        fill='white'
      />
      <path
        d='M11.5 3.16667C11.5 2.24619 12.2462 1.5 13.1667 1.5H14.8333C15.7538 1.5 16.5 2.24619 16.5 3.16667V14.8333C16.5 15.7538 15.7538 16.5 14.8333 16.5H13.1667C12.2462 16.5 11.5 15.7538 11.5 14.8333V3.16667Z'
        fill='white'
      />
      <path
        d='M6.5 14.8333V9.83333C6.5 8.91286 5.75381 8.16667 4.83333 8.16667H3.16667C2.24619 8.16667 1.5 8.91286 1.5 9.83333V14.8333C1.5 15.7538 2.24619 16.5 3.16667 16.5H4.83333C5.75381 16.5 6.5 15.7538 6.5 14.8333ZM6.5 14.8333V6.5C6.5 5.57953 7.24619 4.83333 8.16667 4.83333H9.83333C10.7538 4.83333 11.5 5.57953 11.5 6.5V14.8333M6.5 14.8333C6.5 15.7538 7.24619 16.5 8.16667 16.5H9.83333C10.7538 16.5 11.5 15.7538 11.5 14.8333M11.5 14.8333V3.16667C11.5 2.24619 12.2462 1.5 13.1667 1.5H14.8333C15.7538 1.5 16.5 2.24619 16.5 3.16667V14.8333C16.5 15.7538 15.7538 16.5 14.8333 16.5H13.1667C12.2462 16.5 11.5 15.7538 11.5 14.8333Z'
        stroke='#9CA3AF'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
